// Shared countdown state so every timer on the page (hero card + sticky bar)
// starts from and displays the exact same value.

import { useEffect, useState } from "react";

// Every page load: fresh timer starting from 00 : 14 : 34
export const START_SECONDS = 14 * 60 + 34;

// Module-level deadline — set once when this module first loads.
// Both hero Countdown and sticky FloatingBar read from the same deadline,
// so they'll always tick in lockstep.
export const DEADLINE = Date.now() + START_SECONDS * 1000;

export function useCountdown() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  let diff = Math.max(0, DEADLINE - now);
  const hours = Math.floor(diff / 3600000);
  diff -= hours * 3600000;
  const minutes = Math.floor(diff / 60000);
  diff -= minutes * 60000;
  const seconds = Math.floor(diff / 1000);
  return { hours, minutes, seconds, totalMs: Math.max(0, DEADLINE - now) };
}

export function pad2(n) {
  return String(n).padStart(2, "0");
}
